const brands = {
  frontnode: {
    displayName: 'Frontnode.com',
    landingPageUrl: 'https://frontnode.com/',
    emailRegistration: 'support@frontnode.com',
  },
  omnidrive: {
    displayName: 'Omnidrive.com',
    landingPageUrl: 'https://omnidrive.com/',
    emailRegistration: 'support@omnidrive.com',
  },
  blockforia: {
    displayName: 'Blockforia.com',
    landingPageUrl: 'https://blockforia.com/',
    emailRegistration: 'support@blockforia.com',
  },
  payoro: {
    displayName: 'Payoro.com',
    landingPageUrl: 'https://payoro.com/',
    emailRegistration: 'support@payoro.com',
  },
};

const getBrand = () => {
  return brands[process.env.REACT_APP_BRAND];
};

export const currentBrand = () => getBrand();
